import { render, staticRenderFns } from "./HandoverToOthers.vue?vue&type=template&id=ecf78e78&scoped=true"
import script from "./HandoverToOthers.vue?vue&type=script&lang=js"
export * from "./HandoverToOthers.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./HandoverToOthers.vue?vue&type=style&index=1&id=ecf78e78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf78e78",
  null
  
)

export default component.exports